import { useState } from 'react';
import { SmilePlus } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const QUICK_REACTIONS = ['👍', '❤️', '😊', '😮', '🙏', '😢'];

/**
 * Small "react to this message" control. Shows the current reaction (if
 * any) as a pill, or a subtle add-reaction icon otherwise. Tapping the
 * active emoji again removes the reaction (toggle off); tapping a
 * different one replaces it.
 */
export const QuickReactionPicker = ({ current, onReact, testId }) => {
  const [open, setOpen] = useState(false);
  const pick = (emoji) => {
    onReact(emoji === current ? null : emoji);
    setOpen(false);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`inline-flex items-center justify-center rounded-full transition-colors ${
            current ? 'w-6 h-6 text-sm bg-black/5 hover:bg-black/10' : 'w-6 h-6 text-slate-400 hover:text-slate-600 hover:bg-black/5'
          }`}
          data-testid={`${testId}-trigger`}
          aria-label={current ? `Reacted ${current}, tap to change` : 'React to this message'}
        >
          {current || <SmilePlus className="w-3.5 h-3.5" />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-1.5" align="start" data-testid={`${testId}-panel`}>
        <div className="flex items-center gap-0.5">
          {QUICK_REACTIONS.map((emoji, i) => (
            <button
              key={emoji} type="button"
              onClick={() => pick(emoji)}
              className={`text-lg leading-none p-1.5 rounded-full hover:bg-muted transition-colors ${current === emoji ? 'bg-muted' : ''}`}
              data-testid={`${testId}-option-${i}`}
              aria-label={`React with ${emoji}`}
            >
              {emoji}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
